<template>
  <cast-chart :depth-key="'depth'"
              :parameters="[{'name': 'Temperature', 'id': 'temperature'},
                            {'name': 'Dissolved Oxygen', 'id': 'dissolved_oxygen'},
                            {'name': 'Salinity', 'id': 'salinity'},
                            {'name': 'Chlorophyl A', 'id': 'chloro_a'}]"
              :chart-height="'250px'">
    <b-container fluid class="p-0 pb-2 h-100 border-bottom">
      <b-row no-gutters>
        <b-col cols="7">
          <div class="parameter-box text-truncate">
            <h5>{{ location }}</h5>
            <div class="parameter-name">Location</div>
          </div>
        </b-col>
        <b-col cols="5">
          <div class="parameter-box text-truncate">
            <h5>{{ datetime }}</h5>
            <div class="parameter-name">Timestamp</div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </cast-chart>
</template>

<script>

import CastChart from '@/components/viewers/CastChart.vue'
import { mapGetters, mapState } from 'vuex'
import Helpers from '@/mixins/helpers'
import * as moment from 'moment'

export default {
  components: {
    CastChart
  },
  mixins: [
    Helpers
  ],
  data () {
    return {
      dataset: null,
      datetime: 'Unknown',
      location: 'Unknown'
    }
  },
  mounted: function () {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'add_async_dataset') {
        this.loadData(mutation.payload.platform_id, mutation.payload.dataset_id)
      }
    })
    // Load dataset if already downloaded. Otherwise, 'add_async_dataset' mutation will trigger loading data
    if (this.asyncDatasetSelected !== null && 'data' in this.asyncDatasetSelected) {
      this.loadData(this.asyncDatasetSelected.platform_id, this.asyncDatasetSelected.dataset_id)
    }
  },
  beforeDestroy () {
    // Unsubscribe from mutation
    this.unsubscribe()
  },
  computed: {
    ...mapState(['selectedAsyncDataset', 'platforms']),
    ...mapGetters(['asyncDatasetSelected'])
  },
  methods: {
    loadData: function () {
      if (this.asyncDatasetSelected !== null) {
        this.dataset = this.asyncDatasetSelected
        // Set cast meta data
        if ((this.dataset.latitude !== null) && (this.dataset.longitude !== null)) {
          const loc = this.getCoordinatesNautical(this.dataset.latitude, this.dataset.longitude)
          this.location = loc.lat + ', ' + loc.lng
        } else {
          this.location = 'Unknown'
        }
        // Timestamp
        this.datetime = moment.unix(this.dataset.ts_start).format('MMM D YYYY HH:mm')
      }
    }
  }
}

</script>

<style scoped lang="scss">

</style>
